import React from 'react';
import { siteData } from '../mock/data';
import logo from '../images/ftnl-logo.png';
import teamImage from '../images/profile.png';
import productImage from '../images/project.png';

function App() {
  const {
    navigation,
    hero,
    servicesIntro,
    services,
    credentials,
    approach,
    product,
    contact,
    footer,
  } = siteData;

  return (
    <div className="site-shell">
      <div className="site-background site-background--top" />
      <div className="site-background site-background--bottom" />

      <header className="topbar">
        <div className="container topbar__inner">
          <a className="brand" href="#top" aria-label="FTNL home">
            <img className="brand__logo" src={logo} alt="FTNL logo" />
            <span className="brand__wordmark">FTNL</span>
          </a>

          <nav className="topbar__nav" aria-label="Primary">
            {navigation.map((item) => (
              <a key={item.href} href={item.href}>
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main id="top">
        <section className="hero section">
          <div className="container hero__grid">
            <div className="hero__content">
              <p className="eyebrow reveal reveal--1">{hero.eyebrow}</p>
              <h1 className="hero__title reveal reveal--2">{hero.title}</h1>
              <p className="hero__body reveal reveal--3">{hero.body}</p>

              <div className="hero__actions reveal reveal--4">
                <a className="button button--primary" href={hero.primaryCta.href}>
                  {hero.primaryCta.label}
                </a>
                <a className="button button--secondary" href={hero.secondaryCta.href}>
                  {hero.secondaryCta.label}
                </a>
              </div>

              <div className="hero__metrics reveal reveal--5">
                {hero.metrics.map((metric) => (
                  <div key={metric.label} className="metric-card">
                    <strong>{metric.value}</strong>
                    <span>{metric.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="hero__visual reveal reveal--3">
              <div className="showcase-card">
                <div className="showcase-card__header">
                  <span>{hero.spotlight.label}</span>
                  <a href={product.cta.href} target="_blank" rel="noopener noreferrer">
                    Live preview
                  </a>
                </div>

                <div className="showcase-card__copy">
                  <h2>{hero.spotlight.title}</h2>
                  <p>{hero.spotlight.description}</p>
                </div>

                <div className="showcase-card__media">
                  <img src={productImage} alt="Featured product interface" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section section--intro">
          <div className="container intro-panel">
            <div>
              <p className="section-label">What FTNL does</p>
              <h2>{servicesIntro.title}</h2>
            </div>
            <p>{servicesIntro.body}</p>
          </div>
        </section>

        <section id="services" className="section">
          <div className="container">
            <div className="section-heading">
              <p className="section-label">Services</p>
              <h2>From architecture consulting to shipped delivery.</h2>
              <p>
                We work across product, architecture, and governance so projects are designed with
                intent and delivered with discipline.
              </p>
            </div>

            <div className="service-grid">
              {services.map((service) => (
                <article key={service.title} className="service-card">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container credentials-panel">
            <div className="section-heading section-heading--tight">
              <p className="section-label">Credentials</p>
              <h2>{credentials.title}</h2>
              <p>{credentials.body}</p>
            </div>

            <div className="credential-grid">
              {credentials.items.map((item) => (
                <article key={item} className="credential-card">
                  <p>{item}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="approach" className="section">
          <div className="container approach-grid">
            <div className="section-heading section-heading--tight">
              <p className="section-label">Approach</p>
              <h2>{approach.title}</h2>
              <p>
                The work is structured to reduce ambiguity early, then carry that clarity into
                design, development, and ongoing product management.
              </p>
            </div>

            <div className="approach-steps">
              {approach.steps.map((item) => (
                <article key={item.step} className="approach-step">
                  <span>{item.step}</span>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="product" className="section">
          <div className="container product-panel">
            <div className="product-panel__media">
              <img src={teamImage} alt="FTNL working style illustration" />
            </div>

            <div className="product-panel__content">
              <p className="section-label">{product.label}</p>
              <h2>{product.title}</h2>
              <p>{product.description}</p>

              <ul className="bullet-list">
                {product.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>

              <a
                className="button button--primary"
                href={product.cta.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {product.cta.label}
              </a>
            </div>
          </div>
        </section>

        <section id="contact" className="section">
          <div className="container contact-band">
            <div>
              <p className="section-label">Contact</p>
              <h2>{contact.title}</h2>
              <p>{contact.body}</p>
            </div>

            <a className="button button--primary" href={contact.cta.href}>
              {contact.cta.label}
            </a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer__inner">
          <p>{footer.text}</p>
          <div className="footer__links">
            <a href="#top">Back to top</a>
            <a href={footer.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
